module.exports = __webpack_public_path__ + "static/media/result.b494f728.mp3";